var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M30 9a7 7 0 00-7 7v16.514c-2.443 2.018-4 5.07-4 8.486 0 6.075 4.925 11 11 11s11-4.925 11-11c0-3.416-1.557-6.468-4-8.486V16a7 7 0 00-7-7zm8 32a8 8 0 11-12-6.93V16a4 4 0 018 0v18.07A7.997 7.997 0 0138 41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 15a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM39 19a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM39 23a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM32 25a2 2 0 10-4 0v16a2 2 0 104 0V25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41a6 6 0 11-12 0 6 6 0 0112 0z"
  })));
}

export default SvgIconTemperature;